@if (step === 'select-subscription') {
  <app-select-one-subscription (back)="cancelWorkflow()"
    (selected)="onSubscriptionSelected($event)"
    [historyBackSteps]="2"
  ></app-select-one-subscription>
}
@if (step === 'select-contact') {
  <app-select-invoice-contact
    [customer]="selectedCustomer"
    [subscription]="subscription"
    (selected)="onContactSelected($event)"
  ></app-select-invoice-contact>
}

@if (step === 'select-type' && subscription) {
  <app-select-phonenumber-type (selected)="onPhoneTypeSelected($event)"
    [subscription]="subscription"
    [trunkNumbers]="trunkNumbers"
  ></app-select-phonenumber-type>
}
<!-- AT customer cannot order tenant automatically. We will display info text -->
@if (step === 'contact-sales') {
  <app-phonenumber-contact-sales (selected)="cancelWorkflow()"></app-phonenumber-contact-sales>
}
<!-- PHONE NUMBER PORT -->
@if (step === 'check-drafts') {
  <app-phonenumber-port-drafts
    [drafts]="applianceDrafts"
    (continueDraft)="onDraftSelected($event)"
    (continueNew)="onStartNewPort()"
    [instancename]="subscription.instance_name"
    [id]="selectedApplianceId"
    [company]="company"
  ></app-phonenumber-port-drafts>
}
@if (step === 'port-prepare') {
  <app-phonenumber-port-prepare
  (selected)="onPortPrepare()"></app-phonenumber-port-prepare>
}
@if (step === 'port-number') {
  <app-phonenumber-port
    [countryCode]="subscription?.trunkEnvironment?.tenantCountryCode"
    (selected)="onPortNumbersSelected($event)"
    (back)="cancelWorkflow()"
  ></app-phonenumber-port>
}
@if (step === 'upload-phonebill-form') {
  <app-upload-phonebill-form
    [draftEnabled]="isBillFormDraftEnabled"
    [draftStatus]="draftStatus"
    (selected)="onPhoneBillUploaded($event)"
    (saveDraft)="onSaveDraft('upload_bill')"
    (closeDraft)="cancelWorkflow()"
  ></app-upload-phonebill-form>
}
@if (step === 'prepare-portform') {
  <app-phonenumber-prepare-portform
    [companyName]="company.name"
    (selected)="onCompanyName($event)"
  ></app-phonenumber-prepare-portform>
}
@if (step === 'cancel-provider-connection') {
  <app-cancel-provider-connection
    [portingFormDetails]="portingFormDetails"
    (selected)="onPortFormOptionsSelected($event)"
  ></app-cancel-provider-connection>
}
@if (step === 'download-port-form') {
  <app-download-port-form
    [portingFormDetails]="portingFormDetails"
    (selected)="onPortFormDownloaded($event)"
  ></app-download-port-form>
}
@if (step === 'upload-port-form') {
  <app-upload-port-form
    [draftEnabled]="isPortFormDraftEnabled"
    [draftStatus]="draftStatus"
    (selected)="onPortFormUploaded($event)"
    (saveDraft)="onSaveDraft('upload_port')"
    (closeDraft)="cancelWorkflow()"
  ></app-upload-port-form>
}
@if (step === 'select-port-date') {
  <app-phonenumber-port-date
  (selected)="onPortDateSelected($event)"></app-phonenumber-port-date>
}
<!-- NEW PHONE NUMBER -->
@if (step === 'upload-company-files') {
  <app-upload-company-license  (selected)="onCompanyFilesUploaded($event)"
  ></app-upload-company-license>
}
@if (step === 'select-blocksize' && subscription?.trunkEnvironment) {
  <app-select-phonenumber-blocksize (selected)="onPhoneBlocksizeSelected($event)"
    [trunkEnvironment]="subscription.trunkEnvironment"
  ></app-select-phonenumber-blocksize>
}
@if (step === 'numbers-unavailable') {
  <app-phonenumber-unavailable
    (selected)="onPhonenumberUnavailableBack()"
  ></app-phonenumber-unavailable>
}
@if (step === 'select-phonenumber' && blocks && subscription?.trunkEnvironment) {
  <app-select-phonenumber (selected)="onPhonennumberSelected($event)"
    [blocks]="blocks"
    [maxAllowedAcquiredNumbers]="subscription.trunkEnvironment.maxAllowedAcquiredNumbers"
  ></app-select-phonenumber>
}
@if (step === 'select-loc-ind-phonenumber' && blocks) {
  <app-select-loc-ind-phonenumber (selected)="onLocIndPhonennumberSelected($event)"
    [blocks]="blocks"
  ></app-select-loc-ind-phonenumber>
}
<!-- BOTH -->
<!--Partner-->
@if (step === 'customer-invoice-address') {
  <app-invoice-address
    [company]="company"
    [onlyEmit]="true"
    [backLabel]="backLabel" [validateViaApi]="true"
  (next)="onCustomerInvoiceAddressFilled($event)"></app-invoice-address>
}
@if (step === 'customer-payment-method') {
  <app-payment-method
    [company]="company"
    [onlyEmit]="true"
    [backLabel]="backLabel" (next)="onCustomerPaymentMethodSelected($event)"
    [paymentMethod]="paymentMethod"
  ></app-payment-method>
}
<!--is my-->
@if (step === 'invoice-address') {
  <app-invoice-address [backLabel]="backLabel" [validateViaApi]="true" (next)="onInvoiceAddressFilled($event)"></app-invoice-address>
}
@if (step === 'payment-method') {
  <app-payment-method [paymentMethod]="paymentMethod" [backLabel]="backLabel" (next)="onPaymentMethodSelected($event)"></app-payment-method>
}
@if (step === 'checkout-summary' && subscription) {
  <app-checkout-phonenumber-summary [subscription]="subscription"
    (buy)="onBuy()"
    (cancelBuy)="cancelWorkflow()"
  ></app-checkout-phonenumber-summary>
}
@if (step === 'thank-you') {
  <app-buy-phonenumber-thankyou  [orderName]="orderName"></app-buy-phonenumber-thankyou>
}
@if (step === 'thank-you-partner') {
  <app-buy-thankyou-partner  [orderName]="orderName"></app-buy-thankyou-partner>
}
@if (step === 'select-lac') {
  <app-select-lac [lacList]="lacList" [saleOrderName]="orderName" (back)="onLacBack()" (selected)="onLacSelected($event)"></app-select-lac>
}
